export default "__VITE_ASSET__e3de90d9__"